ready(qs('.CP-search'), () => {
    qs('.CP-search .CP-input').addEventListener('submit', e => {
        const searchInput = qs('.CP-search .CP-input input').value;
        localStorage.clear()
        localStorage.setItem('searchInput', searchInput);
    })

})

ready(qs('.CP-search-results'), () => {
    const searchInput =  localStorage.getItem('searchInput');
    qs('.CP-search .CP-input input').value = searchInput ? searchInput : '';
})


// WEBPACK FOOTER //
// ./src/scripts/components/Search.js